// extracted by mini-css-extract-plugin
export var arrow = "bv_9";
export var background = "bv_y";
export var backgroundContainer = "bv_fC";
export var buttonContainer = "bv_N";
export var categoryOne = "bv_gw";
export var categoryTwo = "bv_gx";
export var container = "bv_b";
export var count = "bv_gG";
export var current = "bv_fz";
export var disclaimer = "bv_cz";
export var gig = "bv_gJ";
export var heading = "bv_G";
export var hidden = "bv_W";
export var icon = "bv_bq";
export var left = "bv_bT";
export var location = "bv_cZ";
export var locations = "bv_gy";
export var locationsMobile = "bv_gq";
export var mobileSelect = "bv_gK";
export var on = "bv_gv";
export var overlay = "bv_gp";
export var plus = "bv_gH";
export var right = "bv_cv";
export var section = "bv_d";
export var selected = "bv_bg";
export var show = "bv_L";
export var speed = "bv_gD";
export var speedContainer = "bv_gC";
export var speedType = "bv_gF";
export var speeds = "bv_gB";
export var speedsUpTo = "bv_gz";
export var subHeading = "bv_H";
export var switcher = "bv_gs";
export var toggle = "bv_gt";
export var toggleContainer = "bv_gr";
export var waveContainer = "bv_d7";
export var waveOne = "bv_q";
export var waveThree = "bv_bZ";
export var waveTwo = "bv_n";
export var waves = "bv_bY";
export var white = "bv_fP";